export { default } from './PartnerOverview'
